<dx-popup class="popup" [showTitle]="true" title="Mitarbeiter bearbeiten" [dragEnabled]="false" [height]="'auto'"
  [width]="'70%'" [hideOnOutsideClick]="false" (onHidden)="onHiddenPopup($event)" (onShowing)="onShowingPopup($event)"
  [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div *ngIf="loading === 1" class="text-center">
            <h1>Lade...</h1>
          </div>
          <div *ngIf="loading === 2" class="text-center">
            <h1>Speichere...</h1>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="loading === 0 && popupVisible === true">
      <dx-form [colCount]="1" [labelLocation]="'top'" #mitAForm [(formData)]="shadowMitarbeiter">
        <dxi-item itemType="group" [colSpan]="1" [colCount]="10">
          <dxi-item itemType="group" [colSpan]="10" [colCount]="12">
            <dxi-item [colSpan]="3" dataField="name" [label]="{text: 'Name'}">
              <dxi-validation-rule type="required" message="Name wird benötigt!"></dxi-validation-rule>
            </dxi-item>
            <dxi-item [colSpan]="3" dataField="vorname" [label]="{text: 'Vorname'}">
              <dxi-validation-rule type="required" message="Vorname wird benötigt!"></dxi-validation-rule>
            </dxi-item>
            <dxi-item [colSpan]="3" dataField="geburtsname" [label]="{text: 'ggf. Geburtsname'}">
            </dxi-item>
            <dxi-item [colSpan]="3" dataField="geburtsdatum" [label]="{text: 'Geburtsdatum'}" editorType="dxDateBox"
              [editorOptions]="{ max: nowDate }">
              <dxi-validation-rule type="required" message="Geburtsdatum wird benötigt!"></dxi-validation-rule>
              <dxi-validation-rule type="custom" [validationCallback]="dateValidationCallback" [reevaluate]="true"
                [min]="minDate" [max]="nowDate" message="Jahr muss zwischen 1900 und heute liegen!">
              </dxi-validation-rule>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colSpan]="10" [colCount]="12">

            <dxi-item [colSpan]="12" [label]="{text: 'Ausbildungen'}" dataField="ausbildungIds"
              [template]="'ausbildungTagTemplate'">
              <dxi-validation-rule type="required" message="Ausbildungen wird benötigt!"></dxi-validation-rule>
            </dxi-item>

            <dxi-item [colSpan]="12" dataField="ausbildungsOrte" [label]="{text: 'genaue Angaben/ weitere Informationen, wie unter Ausbildung gefordert'}"
              *ngIf="showAusbildungsort === true">
              <dxi-validation-rule type="required" message="Ausbildungsort wird benötigt!"></dxi-validation-rule>
            </dxi-item>

          </dxi-item>

          <dxi-item itemType="group" [colSpan]="10">
            <dxi-item [colSpan]="1" itemType="empty">
            </dxi-item>
          </dxi-item>
          <dxi-item *ngIf="!withoutZeugnisCheck" style="margin-top:30px;" [colSpan]="10"
            [label]="{text: 'Zeugniskopien/ Urkunden'}" editorType="dxCheckBox" dataField="zeugUrkchecked"
            [editorOptions]=" { text:'Beiligende Zeugniskopien/ Urkunden wurden durch den Träger im Original eingesehen und stimmen mit den vorgelegten Kopien vollständig überein.'}">
            <dxi-validation-rule type="required" message="Zeugniskopien/Urkunden wird benötigt!"></dxi-validation-rule>
          </dxi-item>
          <dxi-item itemType="group" [colSpan]="10">
            <dxi-item [colSpan]="1" itemType="empty">
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" [colSpan]="10" [colCount]="12">
            <dxi-item [colSpan]="9" [label]="{text: 'Erweitertes Führungszeugnis'}" editorType="dxCheckBox"
              dataField="erwFührZeug"
              [editorOptions]=" {  text:'Ein aktuelles erweitertes Führungszeugnis nach §30 a Abs. 1 BZRG liegt dem Träger vor und:'}">
              <dxi-validation-rule type="required" message="Führungszeugnis wird benötigt!"></dxi-validation-rule>
            </dxi-item>
            <dxi-item [colSpan]="3" dataField="erwFührZeugAustellungsDatum"
              [label]="{text: 'Erstellungsadatum erw. Führungszeugnis'}" editorType="dxDateBox"
              [editorOptions]="{ max: nowDate }">
              <dxi-validation-rule type="required" message="Erstellungsadatum wird benötigt!"></dxi-validation-rule>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" [colSpan]="10" [colCount]="13">
            <dxi-item [colSpan]="1" itemType="empty">
            </dxi-item>
            <dxi-item [colSpan]="2" editorType="dxRadioGroup" dataField="erwFührZeugWithEintrag"
              [editorOptions]="{dataSource: fuehZeugItems, displayExpr: 'text', valueExpr: 'value'}">
              <dxo-label [visible]="false">
              </dxo-label>
              <dxi-validation-rule type="required" message="Führungszeugnis-Eintrag wird benötigt!">
              </dxi-validation-rule>
            </dxi-item>
          </dxi-item>
        </dxi-item>

        <div *dxTemplate="let data1 of 'ausbildungTagTemplate'">
          <div class="ausbildung-editor-container">

            <dx-tag-box class="ausbildung-editor-tagBox" [value]="data1.editorOptions.value"
              [items]="availablAusbildungen" (onValueChanged)="onAusbildungValueChanged($event)" displayExpr="name"
              valueExpr="id" itemTemplate="item">
              <div *dxTemplate="let data of 'item'">

                <div class="ausbildung-editor-tagBox-item-container">
                  <span class="ausbildung-editor-tagBox-item-icon-dummy"
                    *ngIf="data.param.infoLink === undefined || data.param.infoLink === null || data.param.infoLink.length < 1">&nbsp;</span>
                  <i class="dx-icon-help ausbildung-editor-tagBox-item-icon"
                    *ngIf="data.param.infoLink !== undefined && data.param.infoLink !== null && data.param.infoLink.length > 0"
                    id="helpInfoLinkIcon-{{data.id}}"
                    (mouseenter)="showAusbildungEditorInfoLinkItem['i_'+data.id] = true"></i>

                  <span>{{data.name}}</span>
                </div>

                <dx-popover target="#helpInfoLinkIcon-{{data.id}}"
                  *ngIf="data.param.infoLink !== undefined && data.param.infoLink !== null && data.param.infoLink.length > 0"
                  position="top" width="auto" [shading]="true" shadingColor="rgba(0, 0, 0, 0.5)"
                  [(visible)]="showAusbildungEditorInfoLinkItem['i_'+data.id]">

                  <div *dxTemplate="let data3 of 'content'">

                    <div class="ausbildung-infoLink-container">
                      <div class="ausbildung-infoLink-item">
                        <span>Hilfe-Link:</span>
                        <a href="{{buildFullUrl(data.param.infoLink)}}" (click)="disablePopup('i_'+data.id)"
                          target="_blank">{{data.param.infoLink}}</a>
                      </div>
                    </div>

                  </div>
                </dx-popover>

              </div>
              <dx-validator validationGroup="ausbildungenVg1">
                <dxi-validation-rule type="required" message="Ausbildungen wird benötigt!"></dxi-validation-rule>
              </dx-validator>
            </dx-tag-box>
            <dx-button *ngIf="canShoInfoLink" icon="help" type="success" id="ausbildung-editor-infoLink-btn"
              (onClick)="onClickInfoLink(data1.editorOptions.value)"> </dx-button>
          </div>
        </div>

      </dx-form>

    </div>
  </div>
  <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{
                text: 'Übernehmen',
                onClick: onClickUebernehmen
            }">
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{
                text: 'Abbrechen',
                onClick: onClickClose
            }">
  </dxi-popup-toolbar-item>
</dx-popup>


<dx-popover target="#ausbildung-editor-infoLink-btn" position="top" width="auto" [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.5)" [(visible)]="showAusbildungEditorInfoLink">
  <div *dxTemplate="let data of 'content'">

    <div class="ausbildung-infoLink-container">
      <div class="ausbildung-infoLink-item" *ngFor="let infoLinkItem of infoLinkItems">
        <span>{{infoLinkItem.name+':'}} </span>
        <a href="{{infoLinkItem.param.infoLink}}" target="_blank">{{infoLinkItem.param.infoLink}}</a>
      </div>
    </div>

  </div>
</dx-popover>
